import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef, HostListener, input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-dropdown-list',
  templateUrl: './drop-down-list.component.html',
  styleUrls: ['./drop-down-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownListComponent),
      multi: true
    }
  ],
  standalone: true
})
export class DropdownListComponent implements OnInit, ControlValueAccessor {


  protected readonly dropdownListOptions = input.required<Array<{ value: any, label?: string }>>({ alias: 'data' });
  protected readonly center = input<boolean>(true);

  readonly initialSelectValue = { value: '', label: 'Select value' }
  public disabled = false;
  public selected: { value: any, label?: string } = this.initialSelectValue;
  public open = false;
  public value: string | number | object = '';

  constructor(private element: ElementRef, private cd: ChangeDetectorRef) { }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event): void {
    if (!this.element.nativeElement.contains(event.target)) {
      this.open = false;
    }
  }

  ngOnInit(): void {
    this.selected = this.dropdownListOptions()[0] || this.selected;
  }

  onChange: (value: string | number | object) => void = () => { };
  onTouched: () => void = () => { };

  writeValue(value: string | number | object): void {
    this.value = { value: value };
    this.selected = value ? { value } : this.selected
    this.cd.markForCheck()
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  listItemSelected(index: number): void {
    this.selected = this.dropdownListOptions()[index];
    this.open = false;
    this.onChange(this.selected.value);
    this.onTouched();
  }

  trackByValue = (index: number, value: string): string =>
    `${value}-${index}`

  isSelected = (i: number): boolean =>
    this.dropdownListOptions()[i].value === this.selected.value

  toggleOpen = (): boolean =>
    !this.disabled ? (this.open = !this.open) : null
}
